import UserHeaderActionsContainer from 'dpl/containers/Header/UserHeaderActionsContainer';
import DesktopSearchContainer from 'dpl/nav_refresh/containers/DesktopSearchContainer';
import MobileNavContainer from 'dpl/nav_refresh/containers/MobileNavContainer';
import PlatformInfoLinksContainer from 'dpl/nav_refresh/containers/PlatformInfoLinksContainer';
import NavMenuBreedSearchContainer from 'dpl/nav_refresh/containers/NavMenuBreedSearchContainer';
import initReactApp from 'dpl/util/initReactApp';

initReactApp({
  DesktopSearchContainer,
  MobileNavContainer,
  NavMenuBreedSearchContainer,
  PlatformInfoLinksContainer,
  UserHeaderActionsContainer
});
